import { useContext } from 'react';

import { UserDetailContext } from '../contexts/UserDetailContext';

export const useUserDetail = () => {
  const context = useContext(UserDetailContext);

  if (!context) {
    throw new Error('useUserDetail must be used within a UserDetailContext');
  }

  return context;
};
